// extracted by mini-css-extract-plugin
export default {"types-area":"w6zuz0SsvUcKRsUZkNub","types-area-inner":"Rlu4gKVKvoef0XmyDkTQ","type-item":"UVyPJSRAwj6OzUAPmUXn","type-inner":"vfVNUeV6JkGueeAPL_pX"};